import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        height: (props) => `${props.height}` || 600,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    }
}));

export default function CircularIndeterminate(props) {
    console.log(props,"props")
    const classes = useStyles(props);

    return (
        <div className={classes.root}>
            <CircularProgress color="secondary" />
        </div>
    );
}
